




































































import { Observer } from 'mobx-vue'
import { Component, Inject, Ref, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '@/modules/sb-farm/viewmodels/farming-viewmodel'

@Observer
@Component({
  components: {
    'select-lock-period': () => import('@/modules/sb-farm/components/select-lock-period.vue')
  }
})
export default class extends Vue {
  @Inject() vm!: FarmingViewModel
}
